var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activity-content auto-rebalance-failed" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "activity-details" }, [
      _c("div", { staticClass: "detail-item" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Hata:")]),
        _vm._v(" "),
        _c("span", { staticClass: "value error" }, [
          _vm._v(_vm._s(_vm.activity.payload.error)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-item" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Deneme:")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(
            _vm._s(_vm.activity.payload.failedAttempts) +
              "/" +
              _vm._s(_vm.activity.payload.maxFailedAttempts)
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-item" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Eşik Değer:")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(
            _vm._s(_vm.formatPrice(_vm.activity.payload.threshold)) + " TL"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-item" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Hedef Bakiye:")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.formatPrice(_vm.activity.payload.upTo)) + " TL"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "activity-header" }, [
      _c("span", { staticClass: "material-icons error-icon" }, [
        _vm._v("error_outline"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "activity-title" }, [
        _vm._v("Otomatik Bakiye Yükleme Başarısız"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "activity-footer" }, [
      _c("span", { staticClass: "warning-text" }, [
        _c("span", { staticClass: "material-icons" }, [_vm._v("info")]),
        _vm._v(
          "\n            Sistem otomatik olarak tekrar deneyecek. Sorun devam ederse destek ile iletişime geçin.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }